import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledSuggestionItem, StyledSuggestionList } from "../styles";

export type SuggestionsViewProps = PropsWithChildren<{
    title: string;
    suggestions: readonly string[];
    onSuggestionClick: (suggestionText: string) => void;
}>;

export const SuggestedQueriesView = ({ children, title, suggestions, onSuggestionClick }: SuggestionsViewProps) => {
    if (suggestions.length === 0) {
        return null;
    }

    return (
        <Stack
            gap="16px"
            data-automation="suggested-queries-block"
        >
            <Stack gap="8px">
                <Text
                    data-automation="suggested-queries-list-title"
                    fontVariant="sectionTitle"
                    color={colorsPalettes.carbon[400]}
                >
                    {title}
                </Text>

                <StyledSuggestionList data-automation="suggested-queries-list">
                    {suggestions.map((suggestionText, index) => (
                        <StyledSuggestionItem
                            key={index}
                            data-automation={`suggested-queries-item-${index}`}
                            onClick={() => onSuggestionClick(suggestionText)}
                        >
                            {suggestionText}
                        </StyledSuggestionItem>
                    ))}
                </StyledSuggestionList>
            </Stack>

            {children}
        </Stack>
    );
};
